
import { get, post } from '../ApiService'

import config from "@/config"

const encodeBase64Unicode = (str: string) => {
  const utf8Bytes = new TextEncoder().encode(str); // returns Uint8Array
  const binary = Array.from(utf8Bytes).map(b => String.fromCharCode(b)).join('');
  return btoa(binary);
}

export const exportDashboardToExcel = async (data: any) => {

  const url = `${config.apiHost}/dashboard/export-excel/`

  const body = {
    data: encodeBase64Unicode(JSON.stringify(data))
  }

  console.log('data', data)

  return await post(url, body, 'EXPORT_FILE')
}
